import React from 'react'
import { Link } from 'react-router-dom';
// Get styles
import styles from "./../../styles/azkar.module.css";
// Get Images
import VectorLeft from "./../../Images/Desktop-2/Vector-left.png";
function Evening() {
  return (
    <div className={`w-50 me-auto mt-3  ${styles.msaa}`}>
      <div className="relative sbah">
        <Link
          to={`/evening`}
          className={`z-50 ${styles.sbah} text-decoration-none hover:text-gray-300`}
        >
          <img className="h-100 z-10 w-100 absolute" src={VectorLeft} alt="" />
          <div className="p-4 z-20">
            <h3 className="px-1 text-center font-bold z-50">اذكار المساء</h3>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Evening